import { DateTime } from "luxon";
import { useMemo } from "react";
import { isHalloweenSeason } from "../utils/halloweenSeason";

/**
 * Whether Halloween decorations show. Uses the viewer's own calendar, not a department's: it is purely
 * cosmetic, and it also decides the signed-out screens, where no department is chosen yet.
 */
export const useIsHalloweenSeason = (): boolean => useMemo(() => isHalloweenSeason(DateTime.local()), []);
